import '@uppy/core/dist/style.min.css'
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/image-editor/dist/style.min.css';
import '@uppy/webcam/dist/style.min.css';

import { Controller } from "stimulus";
import Uppy from "@uppy/core";
// import Compressor from '@uppy/compressor';
import Dashboard from "@uppy/dashboard";
import ImageEditor from "@uppy/image-editor";
import Webcam from '@uppy/webcam';
import Portuguese from "@uppy/locales/lib/pt_BR";
import ActiveStorageUpload from '../entrypoints/src/lib/uppy_activestorage_upload';

export default class extends Controller {
  static targets = ['photo', 'preview'];

  connect() {
    this.setUppy();
  }

  setUppy() {
    let trigger = this.element.querySelector('[data-behavior="uppy-trigger"]');
    let directUploadURL = document.querySelector("meta[name='direct-upload-url']").getAttribute("content");

    if (!trigger) return;

    let uppy = new Uppy({
      debug: true,
      locale: Portuguese,
      restrictions: {
        maxNumberOfFiles: 1,
        maxFileSize: 3*1024*1024,
        allowedFileTypes: ['image/*']
      },
      allowMultipleUploadBatches: false,
    });

    // uppy.use(Compressor);

    uppy.use(ActiveStorageUpload, {
      directUploadUrl: directUploadURL
    });

    uppy.use(Dashboard, {
      trigger: trigger,
      inline: false,
      proudlyDisplayPoweredByUppy: false,
      allowMultipleUploads: false,
      autoOpenFileEditor: true,
      showProgressDetails: true,
      singleFileFullScreen: true,
      disableInformer: false,
      note: 'Escolha uma imagem apenas de 120x120, de até de 3 MB',
      theme: 'auto'
    });

    uppy.use(ImageEditor, {
      target: Dashboard,
      quality: 0.9,
      cropperOptions: {
        viewMode: 1,
        aspectRatio: 1,
      },
      actions: {
        rotate: true,
        granularRotate: true,
        cropSquare: true,
        cropWidescreen: false,
        cropWidescreenVertical: false,
      }
    });

    uppy.use(Webcam, {
      target: Dashboard
    })

    uppy.on('file-editor:complete', (_) => {
      uppy.getPlugin('Dashboard').requestCloseModal();
      uppy.upload()
    });

    uppy.on('upload-success', (_, response) => {
      $('button[data-submit-form]').prop('disabled', false);
      const files = uppy.getFiles();
      this.setPreview(files[0], response);
      uppy.cancelAll();
    });

    uppy.on('upload', (uploadID, files) => {
      $('button[data-submit-form]').prop('disabled', true);
    });
  }

  setPreview(file, response) {
    if (!this.hasPhotoTarget)
      this.element.insertAdjacentHTML('beforeend', `<input type="hidden" name="${this.element.dataset.attributeName}" data-uppy-photo-target="photo">`)

    this.photoTarget.value = response.signed_id;

    if (this.previewTarget.nodeName === 'IMG') {
      return this.previewTarget.setAttribute('src', file.preview);
    }

    this.previewTarget.innerHTML = `<img src="${file.preview}" class="w-full h-full object-cover group-hover:opacity-60 rounded-full" />`;
  }
}
